<template>
  <v-container fluid class="new-appraisal">
    <div class="new-appraisal-content" v-if="steps">
      <v-stepper v-model="e1">
        <v-stepper-header class="headerFix">
          <template>
            <v-stepper-step
              v-for="n in steps"
              :key="`${n.step}-step`"
              :complete="e1 > n.step"
              :step="n.step"
              editable
              class="w-100"
            >
              <span class="ml-2">{{ n.label }}</span>
              <v-divider v-if="n !== steps" :key="n.step"></v-divider>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in steps"
            :key="`${n.step}-content`"
            :step="n.step"
          >
            <div class="content-step1" v-if="n.step == 1">
              <v-text-field
                v-model="step1.name"
                placeholder="Propietario"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>
              <v-text-field
                v-model="step1.phone"
                placeholder="Telefono"
                type="number"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>
              <v-text-field
                v-model="step1.interesado"
                placeholder="V.Interesado"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>
              <v-text-field
                v-model="step1.entrega"
                placeholder="Entrega inmediata"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>
              <v-text-field
                v-model="step1.brand"
                placeholder="Marca"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>
              <h3>Datos del vehículo</h3>

              <v-text-field
                v-model="step1.model"
                placeholder="Modelo"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.plate"
                placeholder="Matrícula"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.color"
                placeholder="Color"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.kilometers"
                placeholder="Kilómetros"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.engine"
                placeholder="Motor"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.year"
                placeholder="Año"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.itv"
                placeholder="ITV"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-text-field
                v-model="step1.insurance"
                placeholder="Seguro"
                type="text"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-text-field>

              <v-textarea
                v-model="step1.notes"
                label="Observaciones"
                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
              ></v-textarea>

              <h3>Documentación</h3>
              <v-row class="d-flex justify-center align-center mt-5">
                <v-col cols="12">
                  <v-file-input
                    v-model="documentation"
                    color="primary"
                    counter
                    multiple
                    placeholder="Documentación del vehículo"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                    :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip v-if="index < 2" color="primary" dark label small>
                        {{ text }}
                      </v-chip>

                      <span
                        v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                      >
                        +{{ documentation.length - 2 }} Archivo(s)
                      </span>
                    </template>
                  </v-file-input>
                </v-col>
                <!-- Botón de la camara -->
                <v-col cols="1">
                  <v-icon
                    class="cameraIcon"
                    right
                    v-if="platform != 'web'"
                    @click="openCamera('doc')"
                    :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                    >mdi-camera-outline</v-icon
                  >
                </v-col>
              </v-row>

              <h3 v-if="docSelected.length <= 0">
                No hay documentación de este vehículo
              </h3>
              <div v-else class="d-flex justify-center flex-wrap">
                <span v-for="img in docSelected" :key="img.id">
                  <img
                    :src="img.doc"
                    width="350"
                    height="350"
                    style="object-fit: cover; width: 100%; height: auto;"
                    @click="
                      openGallery = true;
                      imagesGallery = img.doc;
                    "
                  />
                </span>
                <!-- <div v-for="img in docSelected" :key="img.id">
                  <v-img
                    :src="img.doc"
                    aspect-ratio="1"
                    max-height="200"
                    max-width="200"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div> -->
              </div>
              <v-btn
                color="primary"
                @click="nextStep(n.step)"
                v-if="userSession.roles[0].rol !== 'ManagerCommercial'"
              >
                GUARDAR
              </v-btn>
            </div>

            <div class="content-step2" v-if="n.step == 2">
              <v-tabs v-model="tab" color="primary" grow>
                <v-tab v-for="item in tabItem" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in tabItem" :key="item">
                  <v-card flat>
                    <v-row class="manual mt-5" v-if="item == 'Manual'">
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Mecánica y Electricidad</h3>
                          <div v-if="isAndroid">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="MOTOR"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="EMBRAGUE"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="CAJA DE CAMBIOS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="DIRECCIÓN"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="4">
                                    <v-textarea
                                      placeholder="VARIOS"
                                      v-model="step2.mechanics_other"
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-textarea>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                          <div v-else>
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="MOTOR"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_engine"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="EMBRAGUE"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_clutch"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="CAJA DE CAMBIOS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_gearbox"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="DIRECCIÓN"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.mechanics_direction"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="4">
                                    <v-textarea
                                      placeholder="VARIOS"
                                      v-model="step2.mechanics_other"
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-textarea>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </div>

                        <div class="mt-5">
                          <h3>Interior</h3>
                          <div v-if="isAndroid">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="VOLANTE"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="ASIENTOS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="TECHO"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="ESTADO GENERAL"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                          <div v-else>
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="VOLANTE"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_steering_wheel"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="ASIENTOS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_seating"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="TECHO"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_roof"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="ESTADO GENERAL"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.interior_general_status"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="2" class="d-flex justify-center">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Exterior</h3>
                          <div v-if="isAndroid">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="LATERAL D"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="LATERAL I"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="P.DELANTERA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="P.TRASERA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="PINTURA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="LUNAS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                          <div v-else>
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="LATERAL D"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_right"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="LATERAL I"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_lateral_left"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="P.DELANTERA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_front"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="P.TRASERA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_back"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="PINTURA"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_general_paint"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="LUNAS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.exterior_windows"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </div>

                        <div class="mt-5">
                          <h3>Neumáticos</h3>
                          <div v-if="isAndroid">
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="DELANTEROS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="TRASEROS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="LLANTAS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="3">
                                    <v-text-field
                                      value="ESTADO GENERAL"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                          <div v-else>
                            <v-simple-table>
                              <thead>
                                <tr>
                                  <th></th>
                                  <th>
                                    Bien
                                  </th>
                                  <th>
                                    Regular
                                  </th>
                                  <th>
                                    Mal
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <v-text-field
                                      value="DELANTEROS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_front"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="TRASEROS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_back"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="LLANTAS"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_llantas"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <v-text-field
                                      value="ESTADO GENERAL"
                                      type="text"
                                      disabled
                                    ></v-text-field>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="green"
                                      value="BIEN"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="yellow"
                                      value="REGULAR"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                  <td>
                                    <v-checkbox
                                      v-model="step2.tires_general_status"
                                      color="red"
                                      value="MAL"
                                      hide-details
                                      :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </div>

                        <div class="mt-5">
                          <h3>Imágenes</h3>
                          <v-row class="d-flex justify-center align-center">
                            <v-col cols="12">
                              <v-file-input
                                class="mt-5"
                                v-model="images"
                                color="primary"
                                counter
                                multiple
                                placeholder="Imágenes del vehículo"
                                prepend-icon="mdi-paperclip"
                                outlined
                                :show-size="1000"
                                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                              >
                                <template v-slot:selection="{ index, text }">
                                  <v-chip
                                    v-if="index < 2"
                                    color="primary"
                                    dark
                                    label
                                    small
                                  >
                                    {{ text }}
                                  </v-chip>

                                  <span
                                    v-else-if="index === 2"
                                    class="text-overline grey--text text--darken-3 mx-2"
                                  >
                                    +{{ images.length - 2 }} Archivo(s)
                                  </span>
                                </template>
                              </v-file-input>
                            </v-col>
                            <v-col cols="1">
                              <v-icon
                                class="cameraIcon"
                                right
                                v-if="platform != 'web'"
                                @click="openCamera('img')"
                                :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                                >mdi-camera-outline</v-icon
                              >
                            </v-col>
                          </v-row>
                        </div>

                        <div class="mt-5">
                          <h3>Galería</h3>
                          <h3 v-if="imagesSelected.length <= 0">
                            No hay imágenes de este vehículo 2
                          </h3>
                          <div v-else class="d-flex justify-center flex-wrap">
                            <span v-for="img in imagesSelected" :key="img.id">
                              <img
                                :src="img.image"
                                width="350"
                                height="350"
                                style="object-fit: cover; width: 100%; height: auto;"
                                @click="
                                  openGallery = true;
                                  imagesGallery = img.image;
                                "
                              />
                            </span>
                            <!-- <div v-for="img in imagesSelected" :key="img.id">
                              <v-img
                                :src="img.image"
                                :lazy-src="img.image"
                                aspect-ratio="1"
                                max-height="200"
                                max-width="200"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </div> -->
                          </div>
                        </div>

                        <div class="mt-5">
                          <h3>Partes seguro</h3>
                          <v-checkbox
                            type="checkbox"
                            label="Parte frontal"
                            v-model="step2.insurance_part_front"
                            :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte trasero"
                            v-model="step2.insurance_part_back"
                            :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte lateral derecho"
                            v-model="step2.insurance_part_llantas"
                            :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte lateral izquierdo"
                            v-model="step2.insurance_part_general_status"
                            :disabled="userSession.roles[0].rol === 'ManagerCommercial'"
                          >
                          </v-checkbox>
                        </div>

                        <v-btn
                          color="primary"
                          @click="nextStep(n.step)"
                          v-if="userSession.roles[0].rol != 'ManagerCommercial'"
                        >
                          GUARDAR
                        </v-btn>
                      </v-col>
                    </v-row>
                    <!-- <div class="automatico" v-else>
                      Automatico
                    </div> -->
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
            <div class="content-step3" v-if="n.step == 3">
              <v-text-field
                v-model="step3.appraised_value"
                placeholder="Precio"
                type="number"
              ></v-text-field>
              <v-btn color="primary" @click="nextStep(n.step)">
                GUARDAR
              </v-btn>
            </div>
            <div class="content-step4" v-if="n.step == 4">
              <v-text-field
                v-model="step4.appraised_value"
                placeholder="Precio"
                type="number"
              ></v-text-field>
              <v-btn
                color="success"
                @click="
                  validate = true;
                  validatemsg(true);
                  nextStep(n.step);
                "
              >
                VALIDAR PRECIO
              </v-btn>
              <v-btn
                color="primary"
                @click="
                  validate = false;
                  validatemsg(false);
                  nextStep(n.step);
                "
              >
                RECHAZAR PRECIO
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
    <!-- Galería de img -->
    <v-dialog
      v-model="openGallery"
      width="1200"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="openGallery = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div>
          <img :src="imagesGallery" style="object-fit: cover; width: 100%;" />
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  postMethodToken,
  postMethodTokenImage,
  getMethodToken,
  postMethodTokenDoc
} from "@/api-consume/api-calls";
import store from "@/store/index";
import { Capacitor } from "@capacitor/core";
import { Camera, CameraResultType } from "@capacitor/camera";

export default {
  props: ["dataSelected"],
  data() {
    return {
      platform: Capacitor.getPlatform(),
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      tab: null,
      tabItem: ["Manual"],
      openGallery: false,
      imagesGallery: [],
      //tabItem: ["Manual", "Automático"],
      e1: 1,
      step1: {
        name: "",
        phone: "",
        interesado: "",
        commercial_user_id: store.state.userLogged.user_id,
        entrega: "",
        brand: "",
        model: "",
        plate: "",
        color: "",
        kilometers: "",
        engine: "",
        year: "",
        itv: "",
        insurance: "",
        notes: ""
      },
      step2: {
        //Mecánica y electricidad
        mechanics_engine: "",
        mechanics_clutch: "",
        mechanics_gearbox: "",
        mechanics_direction: "",
        mechanics_other: "",
        //Interior
        interior_steering_wheel: "",
        interior_seating: "",
        interior_roof: "",
        interior_general_status: "",
        //Exterior
        exterior_lateral_right: "",
        exterior_lateral_left: "",
        exterior_front: "",
        exterior_back: "",
        exterior_general_paint: "",
        exterior_windows: "",
        //Neumáticos
        tires_front: "",
        tires_back: "",
        tires_llantas: "",
        tires_general_status: "",
        //Partes
        insurance_part_front: false,
        insurance_part_back: false,
        insurance_part_llantas: false,
        insurance_part_general_status: false
      },
      step3: {
        appraised_value: "",
        appraiser_user_id: ""
      },
      step4: {
        appraised_value: "",
        validator_user_id: ""
      },
      validate: false,
      images: [],
      imagesSelected: [],
      documentation: [],
      docSelected: [],
      responseId: this.dataSelected.id,
      isAndroid: Capacitor.getPlatform() === "android"
    };
  },

  computed: {
    steps() {
      if (store.state.userLogged.roles[0].rol == "ExternalCommercial") {
        return [
          { label: "Datos de cliente", step: 1 },
          { label: "Datos de vehículo", step: 2 }
        ];
      }
      if (store.state.userLogged.roles[0].rol == "InternalCommercial") {
        return [{ label: "Datos de cliente", step: 1 }];
      }
      if (store.state.userLogged.roles[0].rol == "Appraiser") {
        return [
          { label: "Datos de cliente", step: 1 },
          { label: "Datos de vehículo", step: 2 },
          { label: "Precio del vehículo", step: 3 }
        ];
      }
      if (store.state.userLogged.roles[0].rol == "Validator") {
        return [
          { label: "Datos de cliente", step: 1 },
          { label: "Datos de vehículo", step: 2 },
          { label: "Precio del vehículo", step: 3 },
          { label: "Validación", step: 4 }
        ];
      }
      return [
        { label: "Datos de cliente", step: 1 },
        { label: "Datos de vehículo", step: 2 }
      ];
    }
  },

  async created() {
    this.userSession = JSON.parse(sessionStorage.vuex).userLogged;
    Object.keys(this.dataSelected).forEach(key => {
      if (key in this.step1) {
        this.step1[key] = this.dataSelected[key];
      }
      if (key in this.step2) {
        this.step2[key] = this.dataSelected[key];
      }
      if (key in this.step3) {
        this.step3[key] = this.dataSelected[key];
      }
      if (key in this.step4) {
        this.step4[key] = this.dataSelected[key];
      }
    });

    await this.getDoc();
    await this.getImages();
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },

  methods: {
    async openCamera(to) {
      try {
        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64
        });

        // Convertir la cadena base64 a un Blob
        const base64Data = Buffer.from(image.base64String, "base64");
        const blob = new Blob([base64Data], { type: `image/${image.format}` });

        // Crear un nuevo File a partir del Blob
        const file = new File([blob], `photo_${new Date().getTime()}.jpg`, {
          type: `image/${image.format}`
        });

        if (to == "doc") {
          this.documentation.push(file);
        }

        if (to == "img") {
          this.images.push(file);
        }
      } catch (error) {
        console.error("Error al tomar la foto:", error);
      }
    },
    validatemsg(el) {
      if (el) {
        this.snackbar = true;
        this.snackbarText = "Validado correctamente";
        this.snackbarColor = "green";
      } else {
        this.snackbar = true;
        this.snackbarText = "Precio rechazado";
        this.snackbarColor = "red";
      }
    },
    async getDoc() {
      const response = await getMethodToken(
        "/api/appraisals/docs/" + this.responseId
      );
      console.log("GET LISTA DOCUMENTACION: ", response);

      if (response.status == 200) {
        this.docSelected = response.data.payload.docs;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    async getImages() {
      const response = await getMethodToken(
        "/api/appraisals/images/" + this.responseId
      );
      console.log("LISTA IMAGENES: ", response);

      if (response.status == 200) {
        this.imagesSelected = response.data.payload.images;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    async nextStep(n) {
      var options = {};
      var flag = true;
      switch (n) {
        case 1:
          var check = Object.values(this.step1).some(
            (value, index) =>
              value === "" &&
              !Object.keys(this.step1)[index].startsWith("insurance_")
          );
          if (check) {
            this.snackbar = true;
            this.snackbarText = "Complete todos los campos.";
            this.snackbarColor = "red";
            flag = false;
          }
          options = this.step1;
          options.step_1 = 1;
          options.id = this.responseId;
          break;
        case 2:
          options = this.step2;
          options.step_2 = 1;
          options.id = this.responseId;
          break;
        case 3:
          options = this.step3;
          options.step_3 = 1;
          options.id = this.responseId;
          options.appraiser_user_id = store.state.userLogged.user_id;
          break;
        case 4:
          options = this.step4;
          options.id = this.responseId;
          options.validator_user_id = store.state.userLogged.user_id;
          if (this.validate) {
            options.confirmed = 1;
          } else {
            options.step_3 = 0;
            options.confirmed = 0;
          }
          break;

        default:
          break;
      }

      if (flag) {
        console.log("ENVÍO: ", options);
        const response = await postMethodToken(
          "/api/appraisal/create",
          options
        );
        console.log("CREAR TASACIÓN: ", response);

        if (response.status == 200) {
          this.responseId = response.data.payload.appraisal.id;
          if (n == 1) {
            console.log(
              "ENVÍO documentacion: ",
              this.responseId,
              this.documentation
            );
            for (let x = 0; x < this.documentation.length; x++) {
              const resp = await postMethodTokenDoc(
                "/api/appraisal/docs/upload",
                this.responseId,
                this.documentation[x]
              );
              console.log("SUBIR DOCUMENTACION: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar la documentacion.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n == 2) {
            console.log("ENVÍO IMAGES: ", this.responseId, this.images);
            for (let x = 0; x < this.images.length; x++) {
              const resp = await postMethodTokenImage(
                "/api/appraisal/images/upload",
                this.responseId,
                this.images[x]
              );
              console.log("SUBIR IMAGENES: ", resp);
              if (resp.status != 200) {
                this.snackbar = true;
                this.snackbarText = "Error al guardar las imágenes.";
                this.snackbarColor = "red";
                return 0;
              }
            }
          }
          if (n === this.steps.step) {
            this.e1 = 1;
          } else {
            this.e1 = n + 1;
          }
        } else {
          this.snackbar = true;
          this.snackbarText = "Error al crear la tasación.";
          this.snackbarColor = "red";
        }
      }
    }
  }
};
</script>

<style>
.cameraIcon {
  background-color: #bd1823;
  padding: 10px;
  color: white !important;
  border-radius: 50%;
  font-size: 40px !important;
  cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .headerFix {
    height: auto !important;
  }
  .w-100 {
    width: 100%;
  }
}
</style>
